import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getLocalized, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import { createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import {
	deleteProductSubgroups,
	listProductSubgroups,
	readProductSubgroup
} from "../../redux/actions/table/superadmin/product_subgroups";
import ProductSubgroupsFlyout from "../../flyouts/superadmin/product_subgroups/ProductSubgroupsFlyout";
import TableNA from "../../components/TableNA";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_product_subgroups"],
	application_language_id: state.auth.language_id,
}))
class ProductSubgroups extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_product_subgroup && setPlusActions([{
			title: "Add product subgroup",
			onClick: () => setTableParams('superadmin_product_subgroups', {
				add_product_subgroup_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readProductSubgroup(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		const columns = [
			{
				key: "id",
				name: "ID",
				width: 60,
				sortable: false
			},
			{
				key: "name",
				name: "Name",
				value: name => getLocalized(name, application_language_id)
			},
			{
				key: "priority",
				name: "Priority",
				width: 60,
			},
			{
				key: "product_group",
				name: "Group",
				width: 200,
				value: product_group => {
					const translation = getLocalized(product_group, application_language_id);

					return <Tooltip text={translation}>{translation}</Tooltip>;
				}
			},
			{
				key: "product_category",
				name: "Category",
				width: 200,
				value: product_category => {
					const translation = getLocalized(product_category, application_language_id);

					return <Tooltip text={translation}>{translation}</Tooltip>;
				}
			},
			{
				key: "specification_subgroups",
				name: "Linked Specification Subgroups",
				width: 200,
				sortable: false,
				value: specification_subgroups => {
					specification_subgroups = _.map(specification_subgroups, specification_subgroup_ids => getLocalized(_.get(this.props.localization.specification_subgroups, [specification_subgroup_ids, 'name'], {}), application_language_id));

					return _.isEmpty(specification_subgroups) ? <TableNA /> : <Tooltip text={_.join(specification_subgroups, "\n")}>{_.join(specification_subgroups, ", ")}</Tooltip>;
				}
			},
			{
				key: "product_attribute_fields",
				name: "Assigned Product Attribute Fields",
				sortable: false,
				width: 150,
				value: product_attribute_fields => {
					product_attribute_fields = _.map(product_attribute_fields, product_attribute_field_id => getLocalized(_.get(this.props.localization.product_attribute_fields, [product_attribute_field_id, 'label'], {}), application_language_id));

					return !_.isEmpty(product_attribute_fields) ? (
						<Tooltip text={_.join(product_attribute_fields, "\n")}>{_.join(product_attribute_fields, ", ")}</Tooltip>
					) : <TableNA />;
				}
			}
		];

		const singleActions = (product_subgroup_id) => {
			return [
				<Tooltip text="Delete selected product subgroup" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected product subgroup?\n\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteProductSubgroups([product_subgroup_id]).then(() => {
												hideAlertbox();

												setNotification("The selected product subgroup has been deleted.");
												listProductSubgroups();

												setTableParams('superadmin_product_subgroups', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (product_subgroups_ids) => [
			<Tooltip text="Delete selected product subgroups" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these product subgroups?\n\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteProductSubgroups(product_subgroups_ids).then(() => {
											hideAlertbox();

											setNotification("The selected product subgroups have been deleted.");
											listProductSubgroups();

											setTableParams('superadmin_product_subgroups', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<ProductSubgroupsFlyout
				data={this.state.preview}
				readAction={product_subgroup_id => {
					return new Promise(resolve => {
						readProductSubgroup(getURLParam('id') || product_subgroup_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listProductSubgroups}
				name="superadmin_product_subgroups"
				groupActions={superadmin.delete_product_subgroup && groupActions}
				singleActions={superadmin.delete_product_subgroup && singleActions}
				title={__("modules.submodules.title.product-subgroups")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default ProductSubgroups;
